import styled from '@emotion/styled';

import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const OuterContainer = styled.div`
	width: 100%;
	height: 100%;
	background-color: var(--white);
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 80vw;
	margin: 0 auto;
	margin-top: 1rem;
	margin-bottom: 2rem;
	@media ${Breakpoints.tablet} {
		width: 95%;
		margin: 0 15px !important;
	}
`;

export const Logo = styled(Image)`
	margin: 2rem 0;
	cursor: pointer;
`;

export const Footer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: max(80vw, 360px);
	margin: 0 auto;
	margin-top: auto;
	margin-bottom: 3rem;
	& > span {
		color: #747474 !important;
	}

	& > button > * {
		color: #747474 !important;
	}
`;

export const MiddleContainer = styled.div`
	display: flex;
	width: max(80vw, 360px);
	gap: 1rem;
	margin: 0 auto;
	@media ${Breakpoints.mobile} {
		flex-direction: column-reverse;
	}
`;

export const LeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: max(30vw, 360px);
`;

export const RightContainer = styled.div`
	width: 100%;
	@media ${Breakpoints.mobile} {
		height: 400px;
	}
`;

export const Divider = styled.div`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;

	margin: 1rem auto;
	display: block;
`;

export const ColorDot = styled.div`
	flex-shrink: 0;
	width: 2rem;
	height: 2rem;
	border-radius: 50%;
	background-color: ${({ color }) => color};
	font-weight: 500;
`;

export const TripItem = styled.div`
	display: flex;
	gap: 1rem;
	padding: 1rem 0;

	& > div {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}
`;
